import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import MDBox from "components/MDBox";
import breakpoints from "assets/theme/base/breakpoints";
import colors from "assets/theme/base/colors";
import rgba from "assets/theme/functions/rgba";
import { useMaterialUIController } from "context";

function BaseLayout({ stickyNavbar = false, tabComponents }) {
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);
	const [controller] = useMaterialUIController();
	const {darkMode} = controller;

  useEffect(() => {
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }

    window.addEventListener("resize", handleTabsOrientation);
    handleTabsOrientation();
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, []);

  const visibleTabs = tabComponents.filter((item) =>
    item?.visible === undefined ? true : item?.visible
  );

  return (
    <MDBox>
      <MDBox mt={0.5}>
        <Grid container>
          <Grid item xs={12}>
            {/*<MDBox
              sx={{
                p: 1,
                mb: 2.5,
                borderRadius: "22px",
                //backgroundColor: rgba(colors.white.main, 0.92),
                border: `1px solid ${rgba(colors.secondary.main, 0.1)}`,
                boxShadow: `0 12px 28px ${rgba(colors.dark.main, 0.05)}`,
              }}
            >*/}
              <Tabs
                orientation={tabsOrientation}
                value={tabValue}
                onChange={(event, newValue) => setTabValue(newValue)}
                sx={{
                  minHeight: 0,
                  "& .MuiTabs-indicator": {
                    display: "none",
                  },
                  "& .MuiTabs-flexContainer": {
                    gap: 1,
                    flexWrap: "wrap",
                  },
                }}
              >
                {visibleTabs.map(({ label, icon }) => (
                  <Tab
                    key={label}
                    icon={icon}
                    iconPosition="start"
                    label={label}
                    sx={{
                      minHeight: 46,
                      borderRadius: "14px",
                      px: 2.1,
                      py: 0.8,
                      textTransform: "none",
                      color: colors.text.main,
                      fontWeight: 700,
                      transition: "all 180ms ease",
                      "& .MuiTab-iconWrapper": {
                        mb: "0 !important",
                      },
                      "&:hover": {
                        backgroundColor: rgba(colors.background.muted, 0.42),
                        color: colors.dark.main,
                      },
                      "&.Mui-selected": {
                        color: colors.dark.main,
                        //background: `linear-gradient(335deg, ${colors.light.main} 0%, ${colors.info.main} 150%)`,
												background: darkMode ? rgba(colors.background.muted, 0.42) : `linear-gradient(335deg, ${colors.light.main} 0%, ${colors.info.main} 150%)`,
                        boxShadow: `0 10px 22px ${rgba(colors.dark.main, 0.08)}`,
                      },
                    }}
                  />
                ))}
              </Tabs>
            {/*</MDBox>*/}
          </Grid>
        </Grid>

        {visibleTabs[tabValue]?.component}
      </MDBox>
    </MDBox>
  );
}

BaseLayout.propTypes = {
  stickyNavbar: PropTypes.bool,
  tabComponents: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default BaseLayout;
